import { ImageProps, Slide, TextProps } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from './slide-master';
import { theme } from '../domain/theme';

const TITLE_FONT_SIZE = 48;
const TEAM_MEMBER_FONT_SIZE = 12;
const TEAM_MEMBER_OFFSET = 2.6;

const welcomeText: TextProps = {
  text: 'Welcome'.toUpperCase(),
  options: {
    color: theme.colors.inmarketGreen,
    fontSize: 20,
    charSpacing: theme.charSpacing.veryLoose,
    h: 0.44,
    w: 2.35,
    x: 0.96,
    y: 0.85,
  },
};

const meetYourTeamText: TextProps = {
  text: [
    {
      text: 'Meet ',
      options: {
        fontSize: TITLE_FONT_SIZE,
        color: theme.colors.white,
      },
    },
    {
      text: 'your InMarket team',
      options: {
        fontSize: TITLE_FONT_SIZE,
        color: theme.colors.white,
        bold: true,
      },
    },
  ],
  options: {
    h: 0.91,
    w: 8.8,
    x: 0.86,
    y: 1.19,
    charSpacing: theme.charSpacing.tight,
  },
};

const teamMemberImage = (image: string | null, index: number): ImageProps => ({
  data: image ?? '',
  h: 1.73,
  w: 1.73,
  x: 1.92 + index * TEAM_MEMBER_OFFSET,
  y: 2.85,
});

const teamMemberTitle = (title: string, index: number): TextProps => ({
  text: title,
  options: {
    color: theme.colors.white,
    fontSize: TEAM_MEMBER_FONT_SIZE,
    bold: true,
    align: 'center',
    h: 0.54,
    w: 2.12,
    x: 1.75 + index * TEAM_MEMBER_OFFSET,
    y: 4.84,
    line: {
      color: theme.colors.inmarketGreen,
      width: 1,
    },
    fill: {
      color: '000000',
      transparency: 44,
    },
  },
});

const teamMemberName = (
  firstName: string,
  lastName: string,
  index: number
): TextProps => ({
  text: `${firstName.toUpperCase()}\n${lastName.toUpperCase()}`,
  options: {
    color: theme.colors.inmarketGreen,
    fontSize: TEAM_MEMBER_FONT_SIZE,
    bold: true,
    align: 'center',
    h: 0.5,
    w: 2.12,
    x: 1.75 + index * TEAM_MEMBER_OFFSET,
    y: 5.59,
  },
});

const staticTexts: TextProps[] = [welcomeText, meetYourTeamText];

type MeetYourTeamSlideProps = {
  teamMembers: {
    image: string | null;
    firstName: string;
    lastName: string;
    title: string;
  }[];
};

export const meetYourTeamSlide = (props: MeetYourTeamSlideProps): Slide => {
  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts: [
      ...staticTexts,
      ...props.teamMembers.map((member, index) =>
        teamMemberTitle(member.title, index)
      ),
      ...props.teamMembers.map((member, index) =>
        teamMemberName(member.firstName, member.lastName, index)
      ),
    ],
    images: props.teamMembers.map((member, index) =>
      teamMemberImage(member.image, index)
    ),
  };
};
